import { useState, useEffect } from "react"

const useLocalStorage = (key, initialValue) => {
  const [state, setState] = useState(initialValue)

  useEffect(() => {
    // This effect runs only on the client-side
    try {
      const value = window.localStorage.getItem(key)
      if (value) {
        setState(JSON.parse(value))
      }
    } catch (error) {
      console.log(error)
    }
  }, [key])

  const setValue = value => {
    try {
      // If the passed value is a callback function,
      // then call it with the existing state.
      const valueToStore = value instanceof Function ? value(state) : value
      setState(valueToStore)
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      console.log(error)
    }
  }

  return [state, setValue]
}

export default useLocalStorage